<template>
    <div id="generic_price_table" style="margin-top: 3%;">
        <section>
            <div class="container">
                <div class="row">
                    <div class="col-md-3">
                        <div class="generic_head_price clearfix">
                            <!--HEAD CONTENT START-->
                            <div class="generic_head_content clearfix">
                                <!--HEAD START-->
                                <div class="head_bg"></div>
                                <div class="head">
                                    <span>Lo más visto</span>
                                </div>
                            </div>
                        </div>
                        <div class="generic_content clearfix">
                            <!--HEAD PRICE DETAIL START-->

                            <div class="row mt-3">
                                <div id="carouselLoMasVisto" class="carousel carousel-dark slide carousel-fade"
                                    data-bs-ride="carousel">
                                    <div class="carousel-inner">
                                        <div v-for="(item, index) in losmasvistosprods" :key="'vistos-' + index"
                                            class="carousel-item" :class="{ active: index === 0 }"
                                            data-bs-interval="2000">
                                            <cardprods :item="item" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <!--HEAD PRICE DETAIL START-->
                        <div class="generic_head_price clearfix">

                            <!--HEAD CONTENT START-->
                            <div class="generic_head_content clearfix">
                                <!--HEAD START-->
                                <div class="head_bg"></div>
                                <div class="head">
                                    <span>Lo más buscado</span>
                                </div>
                            </div>
                        </div>
                        <div class="generic_content clearfix">


                            <div class="row mt-3">
                                <div id="carouselLoMasbuscados" class="carousel carousel-dark slide carousel-fade"
                                    data-bs-ride="carousel">
                                    <div class="carousel-inner">
                                        <div v-for="(item, index) in masbuscados" :key="'buscados-' + index"
                                            class="carousel-item" :class="{ active: index === 0 }"
                                            data-bs-interval="2000">
                                            <cardprods :item="item" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="generic_head_price clearfix">

                            <!--HEAD CONTENT START-->
                            <div class="generic_head_content clearfix">

                                <!--HEAD START-->
                                <div class="head_bg"></div>
                                <div class="head">
                                    <span>Últimos Vendidos</span>
                                </div>
                            </div>
                        </div>
                        <div class="generic_content clearfix">

                            <!--HEAD PRICE DETAIL START-->

                            <div class="row mt-3">
                                <div id="carouselprodsultmasvend" class="carousel carousel-dark slide carousel-fade"
                                    data-bs-ride="carousel">
                                    <div class="carousel-inner">
                                        <div v-for="(item, index) in prodsultmasvend" :key="'vendidos-' + index"
                                            class="carousel-item" :class="{ active: index === 0 }"
                                            data-bs-interval="2000">
                                            <cardprods :item="item" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <!--HEAD PRICE DETAIL START-->
                        <div class="generic_head_price clearfix">

                            <!--HEAD CONTENT START-->
                            <div class="generic_head_content clearfix">

                                <!--HEAD START-->
                                <div class="head_bg"></div>
                                <div class="head">
                                    <span>Más Vendido Hoy</span>
                                </div>
                                <!--//HEAD END-->

                            </div>
                        </div>
                        <div class="generic_content clearfix">
                            <div class="row mt-3">
                                <div id="carouselprodsultmasvend" class="carousel carousel-dark slide carousel-fade"
                                    data-bs-ride="carousel">
                                    <div class="carousel-inner">
                                        <div v-for="(item, index) in prodsultmasvendhoy" :key="'hoy-' + index"
                                            class="carousel-item" :class="{ active: index === 0 }"
                                            data-bs-interval="2000">
                                            <cardprods :item="item" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import cardprods from '../PresentacionProductos/cardsprods2.vue'
export default {
    name: 'SeccionProdsDestacar',
    components: {
        cardprods
    },
    data() {
        return {
            losmasvistosprods: [],
            masbuscados: [],
            prodsultmasvend: [],
            prodsultmasvendhoy: [],
        };
    },
    methods: {
        async fetchDataVistos() {
            try {
                const { data } = await axios.get("/homedestacados/vistas");
                this.losmasvistosprods = Object.values(data);
            } catch (error) {
                console.error("Error cargando lo más visto:", error);
            }
        },
        async fetchDataBuscados() {
            try {
                const { data } = await axios.get("/homedestacados/masbuscados");
                this.masbuscados = Object.values(data);
            } catch (error) {
                console.error("Error cargando lo más buscado:", error);
            }
        },
        async fetchDataVendidos() {
            try {
                const { data } = await axios.get("/homedestacados/prodsultmasvend");
                this.prodsultmasvend = Object.values(data);
            } catch (error) {
                console.error("Error cargando últimos vendidos:", error);
            }
        },
        async fetchDataVendidosHoy() {
            try {
                const { data } = await axios.get("/homedestacados/prodsultmasvendhoy");
                this.prodsultmasvendhoy = Object.values(data);
            } catch (error) {
                console.error("Error cargando más vendidos hoy:", error);
            }
        },
    },
    mounted() {
        this.fetchDataVistos();
        this.fetchDataBuscados();
        this.fetchDataVendidos();
        this.fetchDataVendidosHoy();
    },
};


</script>
<style scoped>

/* Texto del header */
.generic_head_price .head span {
    position: relative;
    z-index: 2;
    font-size: 22px;
    font-weight: 600;
    text-transform: uppercase;
    color: #fff;
    letter-spacing: 1.6px;
}

/* Contenedor interno */
.generic_head_content {
    text-align: center;
    width: 100%;
    position: relative;
    z-index: 2;
}

/* Espaciado entre cards */
#generic_price_table .row {
    row-gap: 25px;
}

/* Ajuste hover — cambia tono */
.generic_content:hover .generic_head_price .generic_head_content .head_bg {
    background: linear-gradient(135deg, #cc7a00, #a86900);
}
</style>